import { createApp } from "vue";
import BalloonTipFloating from "../../backend/components/topcer/plugins/balloonTipFloating";
import PageProductCollections from "./PageProductCollections";

const app = createApp({
  components: {
    "page-product-collections": PageProductCollections,

  },
});
app.directive('balloontip', BalloonTipFloating);
app.mount("#page-product-collections");
